import React from 'react'
import { arrayOf, func } from 'prop-types'
import VideoProp from 'utils/prop_types/VideoProp'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'

import VideoCard from 'components/molecules/VideoCard'

const SchoolVideos = ({ videos, handleVideoClick }) => (
  <div className="school-videos" id="videos">
    <SectionContainer
      paddingTop={80}
      paddingBottom={120}
    >
      <Container>
        <SectionTitle title="Video" />
        <Row>
          {
            videos.map((video, idx) => (
              <Col md="4" key={`sch-vid-${video.source}-${idx}`}>
                <VideoCard video={video} onClick={handleVideoClick}/>
              </Col>
            ))
          }
        </Row>
      </Container>
    </SectionContainer>
  </div>
)

SchoolVideos.propTypes = {
  videos: arrayOf(VideoProp),
  handleVideoClick: func,
}

export default SchoolVideos
